import React from 'react';

import classes from '../installPics.css';

import Photo from '../../../../../../../assets/nepPVGaurd.jpg';

const Image = () => (
    <div className={classes.installImages}>
        <img alt="NEP PV Gaurd - Rapid Shutdown Device" src={Photo} className={classes.installImg} />
    </div>
);


export default Image;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/InstallImages/NEP/NEP_1.js